import GeneratingUnitFactory from "../factories/GeneratingUnitFeaturesFactory";
import GeneratingUnitFeaturesActions from "./GeneratingUnitFeaturesActions";
import GeneratingUnitFeaturesGetters from "./GeneratingUnitFeaturesGetters";
import GeneratingUnitFeaturesMutations from "./GeneratingUnitFeaturesMutations";

const state = { ...GeneratingUnitFactory.EmptyState(), error: null };

const namespaced = true;

const { actions } = GeneratingUnitFeaturesActions;

const { mutations } = GeneratingUnitFeaturesMutations;

const { getters } = GeneratingUnitFeaturesGetters;

export default {
	namespaced, state, actions, mutations, getters
};
